import type { ComponentProps } from "react";

const MarketingPlaceIcon = (props: ComponentProps<"svg">) => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_1237_2608)">
        <path
          d="M17.7955 18H0.20459H17.7955ZM7.15914 4.5H11.25V14.3182H7.15914V4.5ZM0.20459 8.59091H4.2955V14.3182H0.20459V8.59091ZM13.7046 0H17.7955V14.3182H13.7046V0Z"
          fill={props.fill || "#183E7A"}
        />
        <path
          d="M17.7955 18H0.20459M7.15914 4.5H11.25V14.3182H7.15914V4.5ZM0.20459 8.59091H4.2955V14.3182H0.20459V8.59091ZM13.7046 0H17.7955V14.3182H13.7046V0Z"
          stroke={props.fill || "#183E7A"}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_1237_2608">
          <rect width="18" height="18" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default MarketingPlaceIcon;
